export const drawerWrapper = {
	borderRadius: '0.5rem',
	padding: '3.3125rem 1rem 4rem 1rem',
	display: 'flex',
	maxWidth: '100%',
	justifyContent: 'space-between',
	alignItems: 'center',
	flexDirection: 'column',
};
